import React, { useState , useEffect } from 'react';
import './style.css';
const getdata = ()=>{
    const data = localStorage.getItem("shiva_todo");
    if(data){
        return JSON.parse(data);
    }
    else{
        return [];
    }
}
const Todocopy = () => {
    const [inputData,setInputData] = useState("");
    const [items,setItems] = useState(getdata());
    const [isedit,setIsedit] = useState("");
    const [toggle,setToggle] = useState(false);

    const addItems = ()=>{
        if(inputData.length === 0){
            alert('pls enter something');
        }
        else if(inputData && toggle){
            setItems(
                items.map((currItem)=>{
                    if(currItem.id === isedit){
                        return {...currItem,name:inputData};
                    }
                    return currItem;
                })
            );
            setIsedit("");
            setToggle(false);
            setInputData([]);
        }
        else {
            const newItem = {
                id:new Date().getTime().toLocaleString(),
                name:inputData,
            };
            console.log(newItem);
            setItems([...items,newItem]);
            setInputData("");
        }
    }
    const editItem = (index)=>{
        const edit_todo = items.find((currItem)=>{
            return currItem.id === index;
        })
        setInputData(edit_todo.name);
        setIsedit(index);
        setToggle(true);
    }

    const deleteItem = (index)=>{
        const deleted_todo = items.filter((currItem)=>{
            return currItem.id !== index;
        })
        setItems(deleted_todo);
    }

    const removeAll = ()=> {
        setItems([]);
    }

    useEffect(()=>{
        localStorage.setItem("shiva_todo",JSON.stringify(items));

    },[items]);
  return (
    <>
    <div className='main-div'>
        <div className='child-div'>
            <figure>
                <img src="./todo.svg" alt="sbh"/>
                <figcaption>Add your Todo's Here👇</figcaption>
            </figure>

                    <div className="addItems">
                        <input type="text"
                        placeholder="✍️ add items"
                        className="form-input"
                        value ={inputData}
                        onChange ={(e)=> setInputData(e.target.value)}
                        />
                        {
                            toggle ? (<i className='far fa-edit add-btn' onClick={addItems}></i>) : (<i className='fa fa-plus add-btn' onClick={addItems}></i>)
                        }
                    
                    </div>
                    <div className="showItems">
                        {
                            items.map((currItem,index)=>{
                                return ( 
                                <div className="eachItem" key={index}>
                            <h3>{currItem.name}</h3>
                            <div className="todo-btn">
                                <i className="far fa-edit add-btn" onClick={()=> editItem(currItem.id)}></i>
                                <i className="far fa-trash-alt add-btn" onClick={()=> deleteItem(currItem.id)}></i>
                            </div>
                        </div>
                                )
                            })
                        }
                    </div>
                    <div className="showItems">
                    <button className="btn effect04" data-sm-link-text="Remove All" onClick={removeAll}>
              <span>Check List</span>
            </button>
                    </div>
                </div>
            </div>
    
    </>
  )
}

export default Todocopy;